import { CloseOutlined } from '@ant-design/icons';
import { Checkbox, Col, Form, Input, Modal, Rate, Row, Select } from 'antd';
import React, { Fragment } from 'react';
import { SlideDown } from 'react-slidedown';
import 'react-slidedown/lib/slidedown.css';
import { titlize } from '../../utils/strings';
import { ButtonType, TAButton } from '../widgets';
import { ActionList, SkillFormContainer, TAAutoComplete, Title } from './styles';

const { Option } = Select;
const filterOptions = (input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;

export const NewSkillForm: React.FC<any> = ({
	onCancel,
	clearOnCancel,
	skillForm,
	proficiencyLevels,
	defaultProficiencyLevel,
	showPlus = true,
	showProficiencyLevels = true,
	skillsOptions,
	visible,
	skillModalFormTitle = 'New Skill',
	cancelText = 'Cancel',
	addText = 'Add',
	mode = 'slide',
	onAdd
}) => {
	const [form] = Form.useForm();

	const onFinish = async values => {
		values.level = proficiencyLevels[values.level - 1];
		onAdd && (await onAdd(values));
		form.resetFields();
	};

	const onFormCancel = e => {
		if (clearOnCancel) form.resetFields();
		onCancel && onCancel();
	};

	let { labels, placeholders, hints } = skillForm;
	let footer = (
		<ActionList align="right">
			<TAButton btntype={ButtonType.SECONDARY} onClick={onFormCancel}>
				{cancelText}
			</TAButton>
			<TAButton btntype={ButtonType.PRIMARY} onClick={form.submit}>
				{addText}
			</TAButton>
		</ActionList>
	);
	let content = (
		<Fragment>
			<Title>{skillModalFormTitle}</Title>
			<Form
				layout="vertical"
				className="ta-form"
				style={{
					backgroundColor: '##1EDCAB0A'
				}}
				form={form}
				onFinish={onFinish}
			>
				<Row gutter={16}>
					<Col xs={{ span: 24 }}>
						<Form.Item
							label={<label className="ta-input-label">{(labels && labels.skillName) || 'Name'}</label>}
							name="name"
							rules={[{ required: true, message: 'please provide the skill name.' }]}
						>
							<TAAutoComplete
								allowClear
								placeholder={placeholders.skillName || 'Enter the skill name.'}
								optionFilterProp="children"
								filterOption={filterOptions}
								style={{ width: '100%' }}
							>
								{skillsOptions &&
									skillsOptions.map(s => (
										<Option value={s} key={s}>
											{titlize(s)}
										</Option>
									))}
							</TAAutoComplete>
						</Form.Item>
					</Col>

					{showProficiencyLevels && (
						<Col xs={{ span: 24 }} md={{ span: 14 }}>
							<Form.Item
								label={
									<label className="ta-input-label">
										{(labels && labels.proficiencyLevel) || 'Proficiency Level'}
									</label>
								}
								name="level"
							>
								<Rate tooltips={proficiencyLevels} style={{ fontSize: '30px' }} allowClear={false} />
							</Form.Item>
						</Col>
					)}

					{showPlus && (
						<Col xs={{ span: 24 }} md={{ span: 10 }}>
							<Form.Item
								label={
									<label className="ta-input-label">{(labels && labels.isPlus) || 'Is plus?'}</label>
								}
								valuePropName="checked"
								name="isPlus"
							>
								<Checkbox>
									<span style={{ color: '#8DABC4' }}>
										{(hints && hints.isPlus) || 'This skill is plus to have.'}
									</span>
								</Checkbox>
							</Form.Item>
						</Col>
					)}

					<Col xs={{ span: 24 }}>
						<Form.Item
							label={<label className="ta-input-label">{(labels && labels.notes) || 'Notes'}</label>}
							name="notes"
							rules={[{ max: 200, message: 'you can enter maximum 200 characters.' }]}
						>
							<Input.TextArea rows={3} />
						</Form.Item>
					</Col>
				</Row>
			</Form>
		</Fragment>
	);
	return mode === 'modal' ? (
		<Modal
			title={skillModalFormTitle}
			visible={visible}
			onOk={form.submit}
			onCancel={onCancel}
			okText={addText}
			footer={footer}
			className="ta ta-modal"
		>
			{content}
		</Modal>
	) : (
		<SlideDown>
			{visible ? (
				<SkillFormContainer>
					<button
						className="slide-close-btn"
						onClick={e => {
							e.preventDefault();
							onCancel(e);
						}}
					>
						<CloseOutlined />
					</button>
					{content} {footer}
				</SkillFormContainer>
			) : null}
		</SlideDown>
	);
};
